/* eslint-disable */
import { Toast } from 'vant'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'

const CommonMethodMixin = {
    methods: {
        /*
        목적: 문자열에서 하이픈 제거
        사용법: replaceAll('010-2222-3333', '-', '') -> 01022223333
        작성자: 김정윤
        */
        removeHipen(val) {
            return val.replace(/-/gi, '')
        },
        /*
        name: replaceAll
        용도: 문자열에서 1) 특정 문자열을 2) 다른 문자열로 치환
        사용법: replaceAll('010-2222-3333', '-', '') -> 01022223333
        작성자: 김정윤
        */
        replaceAll(str, searchStr, replaceStr) {
            return str.split(searchStr).join(replaceStr)
        },
        passwordCheck(val, error, message) {
            let err = error
            let msg = message
            let result = true

            if (!this.emptyCheck(val)) {
                msg.pw = this.$t('TSMO100139')
                err.pw = true
                result = false
            } else if (!this.regexCheck(val, 'password')) {
                msg.pw = this.$t('TSMO100114')
                err.pw = true
                result = false
            }

            return result
        },
        nameCheck(val, error, message) {
            let err = error
            let msg = message
            let result = true

            if (!this.emptyCheck(val)) {
                msg.name = this.$t('TSMO100102')
                err.name = true
                result = false
            }

            return result
        },
        phoneCheck(val, error, message) {
            let err = error
            let msg = message
            let result = true

            if (!this.emptyCheck(val)) {
                msg.phone = this.$t('TSMO100120')
                err.phone = true
                result = false
            } else if (!this.regexCheck(val, 'phone')) {
                msg.phone = this.$t('TSMO100121')
                err.phone = true
                result = false
            }

            return result
        },
        emailCheck(val, error, message) { 
            let err = error
            let msg = message
            let result = true

            if (!this.emptyCheck(val)) {
                msg.email = this.$t('TSOI315098')
                err.email = true
                result = false
            } else if (!this.regexCheck(val, 'email')) {
                msg.email = this.$t('TSMO100103')
                err.email = true
                result = false
            }

            return result
        },
        idCheck(val, error, message) {
            let err = error
            let msg = message
            let result = true

            if (!this.emptyCheck(val)) {
                msg.id = this.$t('TSMO100209')
                err.id = true
                result = false
            } else if (!this.regexCheck(val, 'id')) {
                msg.id = this.$t('TSMO100209')
                err.id = true
                result = false
            } else if (val.length > 60) {
                msg.id = this.$t('TSMO100209')
                err.id = true
                result = false
            }

            return result
        },

        /*
        name: regexCheck
        용도: 1) 정규표현식을 이용해서 타입에 따른 패턴 검사
        작성일: 2019.01.31
        작성자: 김정윤
        수정 계획: 타입 추가
        */
        regexCheck(val, type) {
            let regex
            if (type === 'email') {
                // 1. 이메일
                regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            } else if (type === 'password') {
                // 2. 비밀번호 8~12자의 숫자, 영문자, 특수문자 모두 포함
                regex = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,12}$/
            } else if (type === 'phone') {
                // 3. 전화번호 01011112222
                regex = /^\d{2,3}\d{3,4}\d{4}$/
            } else if (type === 'id') {
                // 4. 아이디 6~10자의 영 소문자 및 숫자
                regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    // regex = /^[0-9a-z]{6,10}$/
            }

            if (!regex.test(val)) {
                return false
            } else {
                return true
            }
        },
        /*
        name: emptyCheck
        용도: text-field의 입력값 여부를 검사
        작성일: 2019.01.31
        작성자: 김정윤
        수정 계획: 없음
        */
        emptyCheck(val) {
            if (val === '' || val === null || val === undefined) {
                return false
            } else {
                return true
            }
        },
        /*
        name: go
        용도: 라우터에 등록된 컴포넌트의 name을 기반으로 이동
        작성일: 2019.01.22
        작성자: 김정윤
        수정 계획: 파라미터 추가
        */
        go(targetName, obj) {

            if (this.$route.name === 'surveyConfirm' && targetName === 'surveyConfirm') {
                // this.$router.go(0)
                this.$router.replace({ path: '/reload' }).then(() => {
                    this.$router.push({ name: targetName }).catch(() => {})
                })
            } else {
                if (this.emptyCheck(obj)) {
                    this.$router.push({ name: targetName, params: obj}).catch(() => {})
                } else {
                    this.$router.push({ name: targetName }).catch(() => {})
                }
            }
        },
        /*
        name: goBack
        용도: 브라우저 히스토리 상 바로 전 페이지로 이동
        작성일: 2019.01.22
        작성자: 김정윤
        */
        goBack() {
            this.$router.go(-1)
        },

        /* ============================================== */
        /* 화면 제어                                       */
        /* ============================================== */
        /*
        name: startLoading
          용도: axios 시작시 Loading toast show
         */
        startLoading(vm) {
            Toast.loading({
                className: vm.$utils.common.getBrandColor(),
                mask: true,
                duration: 100000 // 1분 40초
                    // duration: 3000
            })
        },
        /*
          name: endLoading
          용도: axios 종료시 Loading toast clear
         */
        endLoading(vm) {
            Toast.clear()
        },
        /*
          name: 웨비나 html 타입별 alert
        */
        alertByType(type, idx, msg) {
            let title;
            let okBtnNm;
            //undefined
            try {
                if (type === '01' || type === '02' || type === '03') {
                    msg = idx + this.$t('WEP00009')
                } else if (type === '04') {
                    msg = idx + this.$t('WEP00010')
                } else if (type === '08') {
                    msg = msg + this.$t('WEP00011')
                } else if (type === '11' || type === '12' ) {
                    msg = msg + this.$t('WEP00011')
                } else {
                    if ((type === '06' || type === '07') && idx === 1) {
                        msg = msg + this.$t('WEP00012')
                    } else {
                        msg = msg + this.$t('WEP00013')
                    }
                }
                title = this.$t('WEP00008')
                okBtnNm = this.$t('WEP00006')
            }catch(e){
                let _this = window.vue.getInstance('vue')
                if (type === '01' || type === '02' || type === '03') {
                    msg = idx + _this.$t('WEP00009')
                } else if (type === '04') {
                    msg = idx + _this.$t('WEP00010')
                } else if (type === '08') {
                    msg = msg + _this.$t('WEP00011')
                } else {
                    if ((type === '06' || type === '07') && idx === 1) {
                        msg = msg + _this.$t('WEP00012')
                    } else {
                        msg = msg + _this.$t('WEP00013')
                    }
                }
                title = _this.$t('WEP00008')
                okBtnNm = _this.$t('WEP00006')
            }
            

            let alertParams = { title:title, contents: msg, okBtnNm: okBtnNm }
            let confirmRes = this.$popup.alert(this.$el, alertParams)
            if (confirmRes) {}
        },
        /*
          name: 웨비나 html document 객체 validate  
        */
        documentValidate() { 
            let cnt = document.getElementById('itemCount').value
            let result = {
                flag: true,
                title: [],
                input: [],
                itemType: [],
                actHstrScCd: []
            }

            if (cnt > 0) {
                for (let i = 0; i < cnt; i++) {

                    let data = (document.getElementById('itemTitle' + (i + 1)).value)
                    let titleData = { data }
                    result.title.push(titleData)

                    let itemType = document.getElementById('itemType' + (i + 1)).value // 타입
                    let reqItem = document.getElementById('reqItem' + (i + 1)).value // 필수항목
                    let actHstrScCd = '';
 
                    if (itemType === '08') {
                        actHstrScCd = document.getElementById('actHstrScCd' + (i + 1)).value
                    }

                    let itemTypeData = { itemType, actHstrScCd }
                    result.itemType.push(itemTypeData)

                    if (itemType === '01' || itemType === '09') { // 타입
                        let data = this.inputValidate('radio', 'mtItem' + (i + 1)) // validate
                        if (reqItem === 'Y') {
                            if (isEmpty(data)) {
                                if (itemType === '01') {
                                    this.alertByType(itemType, (i + 1))
                                } else {
                                    this.alertByType(itemType, 0, titleData.data)
                                }
                                result.flag = false
                                return result
                            }
                        }

                        let inputData = { data }
                        result.input.push(inputData)
                    } else if (itemType === '02' || itemType === '08') {
                        let data = []
                        let arrVal = this.inputValidate('checkbox', 'mtItem' + (i + 1))
                        if (reqItem === 'Y') {
                            if (isEmpty(arrVal)) {
                                if (itemType === '02') {
                                    this.alertByType(itemType, (i + 1))
                                } else {
                                    this.alertByType(itemType, 0, titleData.data)
                                }
                                result.flag = false
                                return result
                            }
                        }

                        data.push(arrVal)
                        let inputData = { data }
                        result.input.push(inputData)
                    } else if (itemType === '03') {
                        let data = []
                        let arrVal = this.inputValidate('checkbox', 'mtItem' + (i + 1))
                        let strVal = this.inputValidate('text', 'saItem' + (i + 1))
                        if (reqItem === 'Y') {
                            if (isEmpty(arrVal)) {
                                this.alertByType(itemType, (i + 1))
                                result.flag = false
                                return result
                            }
                        }

                        data.push(arrVal)
                        data.push(strVal)
                        let inputData = { data }
                        result.input.push(inputData)
                    } else if (itemType === '10') { //주소
                        let data = ''
                        var data1 = this.inputValidate('text', 'saItem' + (i + 1))
                        var data2= this.inputValidate('text', 'saItem' + (i + 1) + '-1')
                        var data3= this.inputValidate('text', 'saItem' + (i + 1) + '-2')
                        if (reqItem === 'Y') {
                            if (isEmpty(data1) || isEmpty(data2) || isEmpty(data3)) {
                                this.alertByType(itemType, 0, titleData.data)
                                result.flag = false
                                return result
                            } else {
                                data = data1 + ' / ' + data2 + ' ' + data3
                            }
                        } else {
                            data = data1 + ' / ' + data2 + ' ' + data3
                        }
                      
                        let inputData = { data }
                        result.input.push(inputData)
                    } else if (itemType === '12') {
                        let data = []
                        let arrVal = this.inputValidate('checkbox', 'mtItem' + (i + 1))
                        if (reqItem === 'Y') {
                            if (isEmpty(arrVal)) {                             
                                this.alertByType(itemType, (i + 1), titleData.data)                                
                                result.flag = false
                                return result
                            }
                        }
                        data.push(arrVal)
                        let inputData = { data }
                        result.input.push(inputData)
                       
                    } else if (itemType === '11' ) {
                        let data = this.inputValidate('radio', 'mtItem' + (i + 1)) // validate
                        if (reqItem === 'Y') {
                            if (isEmpty(data)) {
                                this.alertByType(itemType, (i + 1), titleData.data)
                                result.flag = false
                                return result
                            }
                        }
                        let inputData = { data }
                        result.input.push(inputData)
                    } 
                    else {
                        let data = this.inputValidate('text', 'saItem' + (i + 1))
                        if (reqItem === 'Y') {
                            if (isEmpty(data)) {
                                if (itemType === '04') {
                                    this.alertByType(itemType, (i + 1))
                                } else {
                                    this.alertByType(itemType, 0, titleData.data)
                                }

                                result.flag = false
                                return result
                            } else {
                                if (itemType === '06') { 
                                    if (!this.regexCheck(data.trim(), 'email')) {
                                        this.alertByType(itemType, 1, titleData.data)
                                        result.flag = false
                                        return result
                                    }
                                } else if (itemType === '07') {
                                    if (!this.regexCheck(this.removeHipen(data), 'phone')) {
                                        this.alertByType(itemType, 1, titleData.data)
                                        result.flag = false
                                        return result
                                    }
                                }
                            }
                        }

                        let inputData = { data }
                        result.input.push(inputData)
                    }
                }
            }
 
            return result
        },
        /*
          name: 웨비나 html input 객체 validate  
        */
       inputValidate(type, name) {
            let str = ''
            let arr = []

            if (type === 'radio') {
                // for (var radioKey in document.getElementsByName(name)) {
                //     if (document.getElementsByName(name)[radioKey].checked === true) {
                //         str = document.getElementsByName(name)[radioKey].value
                //     }
                // }
                for (var radioKey = 0; radioKey < document.getElementsByName(name).length; radioKey++) {
                    if (document.getElementsByName(name)[radioKey].checked === true) {
                        str = document.getElementsByName(name)[radioKey].value
                    }
                }
            } else if (type === 'checkbox') {
                // for (var checkboxKey in document.getElementsByName(name)) {
                //     if (document.getElementsByName(name)[checkboxKey].checked === true) {
                //         arr.push(document.getElementsByName(name)[checkboxKey].value)
                //     }
                // }
                for (var checkboxKey = 0; checkboxKey < document.getElementsByName(name).length; checkboxKey++) {
                    if (document.getElementsByName(name)[checkboxKey].checked === true) {
                        arr.push(document.getElementsByName(name)[checkboxKey].value)
                    }
                }
            } else {
                str = document.getElementById(name).value
            }

            if (type === 'checkbox') {
                return arr
            } else {
                return str
            }
        },
        goLink(linkUrl, targetNm) {
            
            const agent = window.navigator.userAgent.toLowerCase()
            const appName = window.navigator.appName.toLowerCase()
            // IE일 경우 엣지 실행
            if ((appName === 'netscape' && agent.indexOf('trident') !== -1) || agent.indexOf('msie') !== -1) {
                if (targetNm === ''){
                    targetNm = '_blank'
                }
                let param = { linkUrl: linkUrl, targetNm: targetNm}
                let confirmRes = this.$popup.browserLink(this.$el, param)
                if (confirmRes) {}                
            } else {
                window.open(linkUrl, "link")    
            }
        },
        /*
          name: 웨비나 html 파싱
        */
        getTemplate(resourceUrl, templateStep, next) {
            if (next === 'enter' && this.getStore('mmpAuth').state.wepSets.videoTrnsTyp === '02') {
                next = 'classnow'
                resourceUrl = 'wepAgenda.html'
            }
            resourceUrl = this.getTemplatePath(resourceUrl)
            this.$http.loadRes(resourceUrl).then((res) => {
                if (templateStep === '0') {
                    wepHtmlToString.mainTemplate = res
                } else if (templateStep === '1') {
                    wepHtmlToString.firstSubTemplate = res
                } else if (templateStep === '2') {
                    wepHtmlToString.secondSubTemplate = res
                } else if (templateStep === '3') {
                    wepHtmlToString.thirdSubTemplate = res
                } else if (templateStep === '4') {
                    wepHtmlToString.fourthSubTemplate = res
                } else if (templateStep === '5') {
                    wepHtmlToString.fifthSubTemplate = res
                } else if (templateStep === '6') {
                    wepHtmlToString.sixthSubTemplate = res
                }

                if (!isEmpty(next)) {
                    this.go(next)
                }
            }).catch((ex) => {
                this.go('404')
            })
        },
        getTemplatePath(resourceUrl) {
            if (resourceUrl === 'wepEnter.html' && this.getStore('mmpAuth').state.wepSets.videoTrnsTyp === '02') {
                resourceUrl = 'wepAgenda.html'
            }
            wepHtmlToString.mainTemplateFile = resourceUrl
            resourceUrl = this.getStore('mmpAuth').state.basePath + '/includeHtml/' + localStorage.getItem('language') + '/' + resourceUrl
            if (process.env.NODE_ENV != 'local') {
                resourceUrl = resourceUrl.replace('.html', '.html.org')
                
            }

            return resourceUrl
        },
        setOverflow(isOverFlow) {
            if (isOverFlow) {
                document.querySelector('body').classList.add('popup-open')
            } else {
                document.querySelector('body').classList.remove('popup-open')
            }
        },
        /*
          name: 공통 alert
        */
        commAlert(msg) {
            let title;
            let okBtnNm;
            //undefined
            try {
                title = this.$t('WEP00008')
                okBtnNm = this.$t('WEP00006')
            }catch(e){
                title = _this.$t('WEP00008')
                okBtnNm = _this.$t('WEP00006')
            }
            let alertParams = { title: title, contents: msg, okBtnNm: okBtnNm}
            let confirmRes = this.$popup.alert(this.$el, alertParams)
            if (confirmRes) {}
        },
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        /*
          name: 공통 close-btn
        */
        showCloseBtn(arg1, arg2) {
            if (!isEmpty(document.getElementById(arg1).value)) {
                document.getElementById(arg2).style.display = 'block'
            } else {
                document.getElementById(arg2).style.display = 'none'
            }
        },
        /*
          name: 공통 close-btn 삭제
        */
        clearCloseBtn(arg1, arg2) {
            document.getElementById(arg1).value = ''
            document.getElementById(arg2).style.display = 'none'
        },
        commModal (templateFile) {
          let param = {'templateFile': templateFile}
          this.$popup.WepCommModal(this.$el, param)
        },
        openYoutube (url) {
          let param = {'videoSrc': url, 'templateFile': 'wepYoutube.html'}
          this.$popup.WepCommModal(this.$el, param)
        },
        fnInquiryPopup () {
          window.open(this.getStore('mmpAuth').state.basePath + '/inquiryPopup', 'link')
        },
        fnInquiryLayout () {
          let param = {'isInquiry': true}
          this.$popup.WepSurveyModal(this.$el, param)
        },
        fnPrivacyPolicy (obj) {
          let param = {'policyNum': obj}
          this.$popup.WepPolicyModal(this.$el, param)
        },
        commonPopup (obj) {
          window.open(this.getStore('mmpAuth').state.basePath + '/commonPopup/' + obj, 'link')
        }
    }
}

export default CommonMethodMixin


// WEBPACK FOOTER //
// ./src/mixin/method/CommonMethodMixin.js